<div id="verify" fxLayout="column">

    <div *ngIf="!loading" id="verify-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="verify-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo" *ngIf="verificationStatus == 'esperando'">
                <img src="assets/images/logos/icono.jpg">
            </div>

            <div *ngIf="verificationStatus == 'esperando'" class="title">{{ 'DOCUMENT_VERIFY.INITIAL_TEXT' | translate }}</div>

            <form *ngIf="verificationStatus == 'esperando'" name="verifyForm" [formGroup]="verifyForm" novalidate>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'DOCUMENT_VERIFY.ID' | translate }}</mat-label>
                    <input matInput type="text" formControlName="identifier" (keypress)="eventHandler($event)">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error>
                        {{ 'DOCUMENT_VERIFY.ID_REQUIRED' | translate }}
                    </mat-error>
                </mat-form-field>

                <fieldset class="suavizado" (click)="fileInput.click()">
                    <legend>{{ 'DOCUMENT_VERIFY.FILE' | translate}} *</legend>
                    <button type="button" mat-raised-button
                        [@animate]="{value:'*', params:{delay:'500ms',scale:'0.2'}}">{{ 'DOCUMENT_VERIFY.CHOOSE_FILE' |
                        translate}}</button>
                    &nbsp;<span>{{ fileName }}</span>
                    <input hidden (change)="onFileSelected($event)" formControlName="archivo" #fileInput type="file"
                        id="file" required>
                </fieldset>

                <button mat-raised-button type="submit" color="accent" class="submit-button" aria-label="LOG IN"
                    [disabled]="verifyForm.invalid" (click)="verify()">
                    {{ 'DOCUMENT_VERIFY.VERIFY' | translate }}
                </button>


            </form>

            <div class="resultado" *ngIf="verificationStatus == 'verificado'">
                <mat-icon matSuffix class="green-text">check_circle</mat-icon>
                <div>
                    {{ 'DOCUMENT_VERIFY.VERIFIED' | translate }}
                </div>
                <div>
                    <a class="link" (click)="volverAVerificar()">{{ 'DOCUMENT_VERIFY.BACK_TO_VERIFY' | translate }}</a>
                </div>
            </div>
            <div class="resultado" *ngIf="verificationStatus == 'no_verificado'">
                <mat-icon matSuffix class="red-text">cancel</mat-icon>
                <div>
                    {{ 'DOCUMENT_VERIFY.NOT_VERIFIED' | translate }}
                </div>
                <div>
                    <a class="link" (click)="volverAVerificar()">{{ 'DOCUMENT_VERIFY.BACK_TO_VERIFY' | translate }}</a>
                </div>
            </div>
            <div *ngIf="sesionActiva" class="register" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">{{ 'DOCUMENT_VERIFY.ACCES_PANEL' | translate }}</span>
                <a [routerLink]="'/apps/documents/verification'">{{ 'DOCUMENT_VERIFY.BACK_TO_PANEL' | translate }}</a>
            </div>
            <div *ngIf="!sesionActiva" class="register" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">{{ 'DOCUMENT_VERIFY.ACCES_PANEL' | translate }}</span>
                <a [routerLink]="'/pages/auth/login'">{{ 'DOCUMENT_VERIFY.LOGIN' | translate }}</a>
            </div>
            <div *ngIf="!sesionActiva" class="register" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">{{ 'DOCUMENT_VERIFY.NO_ACCOUNT' | translate }}</span>
                <a [routerLink]="'/pages/auth/register'">{{ 'DOCUMENT_VERIFY.CREATE_ACCOUNT' | translate
                    }}</a>
            </div>
           

        </div>

    </div>

    <app-loading *ngIf="loading"></app-loading>

</div>